import { ReactNode } from 'react'
import { Creator } from '../../gql/types'
import { useContractBlocker } from '../../hooks/useContractProtection'
import { ContractSigningPage } from '../../creators/ContractSigningPage'
import { Loader } from '../Loader'

interface Props {
  creator: Creator | null | undefined
  children: ReactNode
  fallback?: ReactNode
}

/**
 * ContractGate component that checks if creator needs to sign contract
 * Blocks access to children and shows contract signing page if needed
 */
const ContractGate = ({ creator, children, fallback }: Props) => {
  const { shouldBlock, loading, refetchContractStatus } =
    useContractBlocker(creator)

  // Show loading state while checking contract status
  if (loading) {
    return fallback || <Loader />
  }

  // Block access and show contract signing page
  if (shouldBlock && creator) {
    return (
      <ContractSigningPage
        creator={creator}
        onContractSigned={refetchContractStatus}
      />
    )
  }

  // Allow access to protected content
  return <>{children}</>
}

export { ContractGate }
